var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"track-content",rawName:"v-track-content:detail",value:({
    tab_name: 'shanghaieye',
  }),expression:"{\n    tab_name: 'shanghaieye',\n  }",arg:"detail"}],attrs:{"id":"app"}},[(this.$route.path !== '/poster')?_c('Layout'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }